
import React from 'react';
import {connect} from 'react-redux';
import { Formik, getIn } from 'formik';
import * as yup from 'yup';
import { Form, Row, Col, Collapse, Card} from 'react-bootstrap';
import Stats from '../Stats';
import NumberFormat from '../NumberFormat';
import {formatString,formatBoolean,formatPercent,formatCurrency} from '../../ApplicationHelpers';

const schema = yup.object().shape({
    raAccountsTotal: yup.number().required('Please enter total of your retirement accounts'),
    raContributions: yup.number()
  });
// const initialValues = {
//     raAccountsTotal:'',
//     raContributions:''
// };
class Step5 extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
  handleSubmit(values,props) {
    // console.log('---here are values',values);
    values = {
        retirementAccounts: [{
            owner: 'client',
            classification:'Traditional IRA',
            raClassification: 'Traditional IRA',
            riskAllocation: 'Low Risk',
            withdrawalOrder:0,
            preWithdrawalOrder:0,
            monthlyContributionAmount: values.raContributions,
            accountValue: values.raAccountsTotal,
            rateOfReturnAfterRetirement: 0,
           rateOfReturnChange: 0,
                atRisk: formatBoolean(false),
                atRiskAmount: 0,
                lowRiskAmount: 0,
                company: formatString(''),
                accountType: formatString('Checking'),
                investment: formatString('Checking'),
                monthlyContributionPercentIncrease: formatPercent('0%'),
                costBasis: formatCurrency(''),
                rateOfReturn: formatPercent('0%'),
                accountIssueDate: '',
                isGuaranteedIncomeBenefit: formatBoolean(false),
                isSpia: formatBoolean(false),
                isAdvancedAssets: formatBoolean(false),
                accountModifications: [],
                guaranteedIncomeBenefit: {
                    isMonthlyPayoutMode:true
                },
                spia: {},
                beneficiaries: [],
                projectedMonthlyContributions: [],
                stateTax: true,
                savedAs: 'ra'
        }]
    };
    this.props.upliftState(values,'scenario');
    this.props.nextStep();
    return;
  }
   
  render() {
     let isBothRetired = false,  {client,scenario} = this.props.form;
     if(client.isMarried === 'true' && scenario.spouse && scenario.spouse.employment){
        if(scenario.employment.isRetired === 'true' && scenario.spouse.employment.isRetired === 'true'){
            isBothRetired = true;
        }
     }
     else if(scenario.employment.isRetired === 'true'){
        isBothRetired = true;
     }
    return(

                 <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={this.props}
                    validationSchema={schema}
                    onSubmit={this.handleSubmit}
                >
                {({
                        handleSubmit,
                        handleChange,
                        setFieldValue,
                        setFieldTouched,
                        handleBlur,
                        values,
                        errors,
                        touched,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit} >
                            <Card className="stepChild">
                            <Card.Header>
                                <Row >
                                <span style={{'position':'absolute','paddingLeft':'15px'}}><strong>5.</strong></span>
                                    <Col md={"10"} sm={"12"} style={{'paddingLeft':'35px'}}>
                                        {this.props.getStepHeader(5) } 
                                    </Col>
                                    <Col md={"2"} sm={"12"}>
                                        <Stats type="edit" step={5} {...this.props} />
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Collapse in={this.props.isActive}>
                            <Card.Body>
                             <Form.Row>
                            <Form.Group as={Col} md="6" controlId="validationFormikraAccountsTotal">
                            <Form.Label className="required">Total Account Value</Form.Label>
                                <NumberFormat
                                value={values.raAccountsTotal} 
                                thousandSeparator={true} 
                                prefix={'$'} 
                                onValueChange={e => {  setFieldValue( 'raAccountsTotal', e.floatValue);
                                            setFieldTouched( 'raAccountsTotal',true);  }}
                                error={ getIn(errors,'raAccountsTotal') }
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="6" controlId="validationFormikraContributions">
                            <Form.Label>Monthly Contributions to Accounts</Form.Label>
                                <NumberFormat
                                disabled={isBothRetired}
                                value={values.raContributions} 
                                thousandSeparator={true} 
                                prefix={'$'} 
                                onValueChange={e => {  setFieldValue( 'raContributions', e.floatValue);
                                            setFieldTouched( 'raContributions',true);  }}
                                error={ getIn(errors,'raContributions') }
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md="12" style={{"padding":"0px","margin":"0px"}} controlId="step5Continue">
                                <Col md={"12"} sm={"12"}>
                                    <Stats type='continue' step={5} {...this.props} />
                                </Col>
                            </Form.Group>
                        </Form.Row>
                        </Card.Body>
                        </Collapse>
                        </Card>
                        </Form>
                    )}
                    </Formik>
    );
   }
}
const mapStateToProps = (state , ownProps) => {
    let {form} = state.mainState;
    let {client,scenario} = form;
        if(!client.isMarried || client.isMarried === 'false'){
            client.spouse = {};
            scenario.spouse = {employment:{}};
        }
        let ra = {};
        if(Array.isArray(scenario.retirementAccounts)){
            ra = scenario.retirementAccounts[0];
        }
        return {
            form,
            isMarried:client.isMarried,
            raContributions:ra.monthlyContributionAmount,
            raAccountsTotal: ra.accountValue,
            scenario,
            ...ownProps
        }
  }
 export default connect(
    mapStateToProps,
    null
  )(Step5)